import { connectStepper } from "../util/redux";
import Time from "../components/time";

export default connectStepper(Time);
